<template>
  <CoursePage v-bind="$props" />
</template>

<script>
import CoursePage from '~contemporaryTheme/pages/courses/_id'

export default {
  components: {
    CoursePage,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
}
</script>
